import { useState } from "react";
import CalendarGrid from "./CalendarGrid";
import { getFileByModule } from "../../services/FilesService/FilesService";
import { toast } from "react-hot-toast";
import { useFilePreview } from "../../hooks/useFilePreview";
import FilePreviewModal from "../../components/FilePreviewModal/FilePreviewModal";
import FileActions from "../../components/FilePreviewModal/FileActions";
import { downloadFile } from "../../utils/fileUtils";

const groups = ["Кіші топ", "Ортаңғы топ", "Ересек топ", "Мектепалды топ"];

const months = [
  "Қаңтар",
  "Ақпан",
  "Наурыз",
  "Сәуір",
  "Мамыр",
  "Маусым",
  "Шілде",
  "Тамыз",
  "Қыркүйек",
  "Қазан",
  "Қараша",
  "Желтоқсан",
];

const Cyclogram = () => {
  const [selectedGroup, setSelectedGroup] = useState("Мектепалды топ");
  const [selectedDate, setSelectedDate] = useState(
    new Date(new Date().getFullYear(), 8, 1)
  );

  // Use the reusable file preview hook
  const { isPreviewOpen, previewUrl, isLoading, openPreview, closePreview } =
    useFilePreview();

  const ageMap = {
    "Кіші топ": "2-3 жас",
    "Ортаңғы топ": "3-4 жас",
    "Ересек топ": "4-5 жас",
    "Мектепалды топ": "5-6 жас",
  };

  const groupMap = {
    "Кіші топ": "kishi_top",
    "Ортаңғы топ": "ortangy_top",
    "Ересек топ": "eresek_top",
    "Мектепалды топ": "mektep_aldy_top",
  };

  const selectedMonthName = months[selectedDate.getMonth()];

  const fetchFileMeta = async () => {
    try {
      const response = await getFileByModule({
        module_code: "cyclogram",
        month: selectedDate.getMonth() + 1,
        group: groupMap[selectedGroup],
      });

      if (!response?.file) {
        toast.error("Файл табылмады.");
        return null;
      }
      return response.file;
    } catch (err) {
      console.error("Fetch error:", err);
      toast.error("Файл табылмады немесе қате болды.");
      return null;
    }
  };

  const handlePreview = async () => {
    const file = await fetchFileMeta();
    if (!file) return;

    await openPreview(file.file_url, file.file_name);
  };

  const handleDownload = async () => {
    const file = await fetchFileMeta();
    if (!file) return;

    downloadFile(file.file_url, file.file_name);
  };

  return (
    <div className="flex flex-col flex-1 items-center justify-center p-16">
      <h1 className="text-3xl text-[#674DA2] mb-12 text-center">
        Шабыт қоржыны
      </h1>
      <main className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-5xl bg-white rounded-xl p-6 shadow-md">
        {/* Calendar */}
        <div className="bg-white p-6 rounded-2xl shadow-xl">
          <CalendarGrid
            selectedDate={selectedDate}
            onSelectDate={setSelectedDate}
          />
        </div>

        {/* Group + Actions */}
        <div className="bg-white p-6 rounded-2xl shadow-xl flex flex-col justify-between">
          <div>
            <h2 className="font-bold text-xl mb-6">Топтар</h2>
            <div className="grid grid-cols-2 gap-4">
              {groups.map((group) => (
                <button
                  key={group}
                  onClick={() => setSelectedGroup(group)}
                  className={`py-6 rounded-2xl text-center font-semibold transition-colors ${
                    selectedGroup === group
                      ? "bg-[#674DA2] text-white hover:bg-[#5b4196]"
                      : "bg-[#EDE7F6] text-[#674DA2]-900 hover:bg-[#674DA2] hover:text-white"
                  }`}
                >
                  {group} <br /> ({ageMap[group]})
                </button>
              ))}
            </div>
          </div>

          {/* Use the reusable FileActions component */}
          <FileActions
            onPreview={handlePreview}
            onDownload={handleDownload}
            isLoading={isLoading}
            className="mt-4"
          />

          {/* Selected month and group info */}
          <p className="mt-2 text-xs text-slate-600">
            Таңдалған ай: <strong>{selectedMonthName}</strong> · Топ:{" "}
            <strong>{selectedGroup}</strong>
          </p>
        </div>
      </main>

      {/* Use the reusable FilePreviewModal component */}
      <FilePreviewModal
        isOpen={isPreviewOpen}
        previewUrl={previewUrl}
        onClose={closePreview}
        title={`Шабыт қоржыны - ${selectedGroup} - ${selectedMonthName}`}
      />
    </div>
  );
};

export default Cyclogram;
